import isFunction from 'lodash/isFunction';

export default (val, validators = [], { state = {}, props = {} } = {}) => {
  const errorMessages = [];
  const isValid = validators.reduce((previousIsValid, validator) => {
    const {
      callback,
      errorMessage = '',
      options: optionsIn = {},
      stateSelector = null,
    } = validator;

    const validationResponse = callback(val, {
      ...optionsIn,
      ...(stateSelector ? stateSelector(state) : {}),
      ...props,
    });

    // validationResponse can be either boolean or an error object
    const isValid =
      typeof validationResponse === 'boolean' ? validationResponse : !validationResponse.error;

    if (!isValid) {
      errorMessages.push(
        isFunction(errorMessage)
          ? errorMessage(stateSelector ? stateSelector(state) : {})
          : errorMessage,
      );
    }

    return previousIsValid && isValid;
  }, true);

  return {
    isValid,
    errorMessage: isValid ? null : errorMessages[0],
    errorMessages,
  };
};
